import { Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useApp } from "@/store/useApp";
import { Button } from "@/components/ui/button";
import { Truck, LogOut } from "lucide-react";
import { isAdminEquivalent } from "@/lib/types";

export function DriverLayout() {
  const account = useApp((s) => s.account);
  const logout = useApp((s) => s.logout);
  const navigate = useNavigate();

  useEffect(() => {
    if (!account) {
      navigate("/login", { replace: true });
      return;
    }
    if (account.role !== "ENTREGADOR" && !isAdminEquivalent(account.role)) {
      navigate("/", { replace: true });
    }
  }, [account, navigate]);

  if (!account) return null;
  if (account.role !== "ENTREGADOR" && !isAdminEquivalent(account.role)) return null;

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-card">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2">
            <Truck className="h-5 w-5 text-primary" />
            <span className="font-semibold">Entregas</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <span className="hidden text-muted-foreground sm:inline">{account.email}</span>
            <Button
              variant="ghost"
              size="sm"
              onClick={async () => {
                await logout();
                navigate("/login", { replace: true });
              }}
            >
              <LogOut className="mr-1 h-4 w-4" /> Sair
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-4 py-4">
        <Outlet />
      </main>
    </div>
  );
}
